import React, { Component } from "react";
import Details from "../../components/subscriptions/Details";
import PageHeader from "../../components/PageHeader";
import {
  Button,
  Confirm,
  Divider,
  Segment,
  Menu,
  Form,
  Message,
  Modal,
  Icon,
  Dropdown
} from "semantic-ui-react";
import ReactTable from "react-table";
import request from "../../utils/request";
import matchSorter from 'match-sorter';
import { formatCurrency } from "../../utils/constants";
import { AppContext } from "../../utils/context";
import Pagination from '../../components/subscriptions/Pagination';

class Subscription extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMounted: false,
      isLoading: false,
      sort: [{ id: "status", desc: false }, { id: "id", desc: false }],
      data: [{
        id: "",
        subscriptionId: "",
        orderId:"",
        customerId: "",
        status: "",
        last_name: "",
        first_name: "",
        email: "",
        eventTitle: "",
        totalCost: "",
        type: "",
      }],
      query: "",
      limit: 20,
      pages: null,
      page: 1,
      total: 0,
      confirm: {
        open: false,
        id: 0,
        content: "",
        idDone: this.confirmClose
      },
      modal: {
        ids: [],
        content: "",
        isOpen: false,
        isDone: this.confirmModalClose
      },
      addGroupModalOpen: false,
      totalSubscriptionCount: 0,
      totalSubscriptionAmount: "$0.00",
      newGroupName: "",
      groupName:"",
      subscriptionLicense: "",
      modalErrorMessages: [],
      modalSuccessMessages: "",
      subscriptionGroups: [],
      xhrMessages: [],
      xhrStatus: "",
      selectedGroup: "",
      activateEventName: "",
      activateEventId: "",
      filtered: {
        email: "",
      },
    };
  }
  componentDidMount = () => {
    this.setState({ isMounted: true });
    this.fetchData();
    this.fetchSubscriptionGroups();
    this.interval = setInterval(this.fetchSubscriptionGroups, 30000);
  }

  componentWillUnmount = () => {
    clearInterval(this.state.pollInterval);
  };

  fetchSubscriptionGroups = () => {
    this.setState({ isLoading: true });

    request
    .get(this, "api:/get-subscription-groups")    
    .then(resp => {
      if (resp.status == 'error' || resp.success == false) {
        this.setState({
          isLoading: false,
          xhrMessages: [resp.message?? resp.data],
          xhrStatus: "error"
        })
      } else {
        this.setState({
          isLoading: false,
          subscriptionGroups: resp.data,
        })
      }
    })
    .catch(err => this.setState({
      isLoading: false,
      xhrMessages: [err],
      xhrStatus: "error"
    }));
  }

  fetchData = (groupId = null, page = null) => {
    this.setState({ isLoading: true });
    let payload = {'limit': this.state.limit, 'page':page ?? this.state.page,}    
    if (groupId != null && groupId != "") {
      payload.group_id = groupId;
    }
    if (this.state.filtered.email)  {
      payload.email = this.state.filtered.email;
    }

    request
      .post(this, "api:/shopify-subscriptions", payload)
      .then(resp => {
        if (resp.status == 'error' || resp.success == false) {
          this.setState({
            isLoading: false,
            xhrMessages: [resp.message?? resp.data],
            xhrStatus: "error"
          });
        } else if (resp.data.length == 0) {
            this.setState({
              isLoading: false,
              data: resp.data,
              pages: 0,
              xhrMessages: ["No data found"],
              xhrStatus: "error"
            });  
        } else {
          this.setState({
            xhrMessages: [],
            xhrStatus: "",
            isLoading: false,
            data: resp.data,
            page: resp.pagination.current_page, 
            pages: Math.ceil(resp.pagination.total / this.state.limit)
          });
        }
      })
      .catch(err => {
        this.setState({
          isLoading: false,
          xhrMessages: [err],
          xhrStatus: "error"
        });
      });
  };

  confirmModalOpen = (id, title, callback) => {
    if (!callback) callback = this.confirmModalClose;
    if (!this.state.confirm.open) {
      if (this.state.activateEventName == null) {
        title = "No Active Event for this subscription Group. No order will be created";
      }
      if (this.state.activateEventName == "") {
        title = 'No subscription group selected';
      }
      this.setState({
        modal: {
          ids: id,
          content: title,
          isOpen: true,
          isDone: callback
        }
      });
    }
  };

  confirmModalClose = callback => {
    this.setState(
      {
        modal: {
          ids: [],
          content: "",
          isOpen: false,
          isDone: this.confirmModalClose
        },
      },
      callback
    );
  };

  handleFilter = (e, { name, value }) => {
    let filters = this.state.filtered;
    filters[name] = value;
    this.setState({ filtered: filters });
  };

  handleClearSearch = (e, { name, value }) => {
    let filters = this.state.filtered;
    filters.email = "";
    this.setState({filtered: filters}, () => this.fetchData(null));
  };

  triggerPayment = () => {
    this.setState({ isLoading: true });
    let payload = {'event_subscription_group_id': this.state.selectedGroup, 'event_id': this.state.activateEventId}
    request
      .post(this, "api:/trigger-subscriptions", payload)
      .then(resp => {
        if (resp.status == 'error' || resp.success == false) {
          this.setState({
            isLoading: false,
            xhrMessages: [resp.message?? resp.data],
            xhrStatus: "error"
          },this.confirmModalClose());
        } else {
          this.setState({
            isLoading: false,
            xhrStatus: 'success',
            xhrMessages: ['success']
          },this.confirmModalClose());
        }
      })
      .catch(err => {
        this.setState({
          isLoading: false,
          xhrMessages: [err],
          xhrStatus: "error"
        },this.confirmModalClose());
      });
  }

  cancelSubscription = () => {
    this.setState({ isLoading: true });
    if (this.state.selectedGroup == "") {
      this.setState({
        isLoading: false,
        xhrMessages: ["no subscription group selected"],
        xhrStatus: "error"
      },this.confirmModalClose());
      return;
    }
    let payload = {'event_subscription_group_id': this.state.selectedGroup}
    request
      .post(this, "api:/cancel-all-subscriptions", payload)
      .then(resp => {
        if (resp.status == 'error' || resp.success == false) {
          this.setState({
            isLoading: false,
            xhrMessages: [resp.message?? resp.data],
            xhrStatus: "error"
          },this.confirmModalClose());
        } else {
          this.setState({
            isLoading: false,
            xhrStatus: 'success',
            xhrMessages: ['success']
          },this.confirmModalClose(this.fetchData(this.state.selectedGroup)));
        }
      })
      .catch(err => {
        this.setState({
          isLoading: false,
          xhrMessages: [err],
          xhrStatus: "error"
        },this.confirmModalClose());
      });
  }

  deactivateSubscription = (e) => {
    this.setState({
      confirm: {
        open: true,
        id: e.currentTarget.dataset.id,
        content: e.currentTarget.dataset.message
      }
    });
  }

  cancelDelete = () => {
    this.setState({
      confirm: {
        open: false,
        id: 0,
        content: ""
      }
    });
  }

  activeSubscription = (e) => {
    let payload = {
      'subscription_id': e.currentTarget.dataset.id,
      'data': {
        status: 'ACTIVE'
      }
    }

    return request.post(this, `api:/subscriptions-update`, payload)
    .then(resp => {
      if (resp.status == 'error' || resp.success == false) {
        this.setState({
          isLoading: false,
          xhrMessages: [resp.message?? resp.data],
          xhrStatus: "error",
        });
      } else {
        this.setState({
          isLoading: false,
          xhrStatus: 'success',
          xhrMessages: ['success'],
        }, this.fetchData(this.state.selectedGroup));
      }
    }).catch(err => {
      this.setState({
        isLoading: false,
        xhrMessages: [err],
        xhrStatus: "error"
      });
    });
  }

  confirmDelete = () => {
    const { confirm } = this.state;
    let payload = {
      'subscription_id': confirm.id,
      'data': {
        status: 'CANCELLED'
      }
    }
    return request.post(this, `api:/subscriptions-update`, payload)
      .then(resp => {
        if (resp.status == 'error' || resp.success == false) {
          this.setState({
            isLoading: false,
            xhrMessages: [resp.message?? resp.data],
            xhrStatus: "error",
            confirm: {
              open: false,
              id: 0,
              content: ""
            }
          }, this.cancelDelete);
        } else {
          this.setState({
            isLoading: false,
            xhrStatus: 'success',
            xhrMessages: ['success'],
            confirm: {
              open: false,
              id: 0,
              content: ""
            }
          }, this.fetchData(this.state.selectedGroup));
        }
      }).catch(err => {
        this.setState({
          isLoading: false,
          xhrMessages: [err],
          xhrStatus: "error"
        },this.confirmModalClose());
      });
  }

  handleAddGroupModalOpen = () => {
    this.setState({addGroupModalOpen: true});
  }

  handleAddGroupModalClose = () => {
    this.setState({addGroupModalOpen: false, modalErrorMessages: [], modalSuccessMessages: ""});
  }

  handlePageChange = newPage => {
    this.setState({ page: newPage }, () => {
        this.fetchData(this.state.selectedGroup);
    });
}

  handleNewGroupSave  = () => {
    let payload = {
      'name' : this.state.newGroupName,
      'license': this.state.subscriptionLicense
    }
    return request.post(this, `api:/create-subscription-group`, payload)
    .then(resp => {
      if (resp.status == 'error' || resp.success == false) {
        this.setState({modalErrorMessages: [resp.message], modalSuccessMessages: "" });
      } else {
        this.setState({ newGroupName: '', subscriptionLicense: '', modalErrorMessages: [], modalSuccessMessages: "success create subscription group" }, this.fetchSubscriptionGroups());
      }
    })
    .catch(err => {
      this.setState({ 
        errorMessages: ['Network error: ' + err.message], 
        successMessage: '',
      });
    });
    
  }

  render() {
    const {
      confirm,
      data,
      limit,
      pages,
      isLoading,
      xhrMessages,
      xhrStatus,
      filtered,
      modal,
      addGroupModalOpen
    } = this.state;
    const { config } = this.context;
    const subscriptionEnabled = config.subscription_enabled
    const columns = [
      {
        expander: true,
        Header: () => <strong>More</strong>,
        width: 65,
        Expander: ({ isExpanded, ...rest }) => (
        <div style={{ display: (rest.original && rest.original.detail && rest.original.detail.length === 0)  ? "none" : "block" }}>
            {isExpanded ? (
            <Icon name="caret down" />
            ) : (
                <Icon name="caret right" />
            )}
        </div>
        ),
        style: {
        cursor: "pointer",
        fontSize: 25,
        padding: "0",
        textAlign: "center",
        userSelect: "none"
        },
        filterable: false
     },
      {
        accessor: d => (
          <div>
          <Button icon="trash" color="red" data-id={d.id} data-message={`Are you sure you want to delete this subscription?`} onClick={this.deactivateSubscription} disabled = {d.status == "CANCELLED"} />
          <Button icon="unlock" color="green" data-id={d.id} onClick={this.activeSubscription} disabled = {d.status == "ACTIVE"}/>
          </div>
        ),
        id: "action",
        Header: "Action",
        sortable: false,
        filterable: false
      },

      {
        accessor: d => (d.id),
        id: "id",
        Header: "ID",
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, { threshold: matchSorter.rankings.CONTAINS, keys: ["id"] }),
        filterAll: true
      },
      {        
        accessor: d => (d.subscription_title),
        id: "subscriptionTitle",
        Header: "Subscription Title",
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, { threshold: matchSorter.rankings.CONTAINS, keys: ["subscriptionTitle"] }),
        filterAll: true
      },
      {
        accessor: d =>  (d.email),
        Header: "Email",
        id: "email",
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, { threshold: matchSorter.rankings.CONTAINS, keys: ["email"] }),
        filterAll: true
      },
      {        
        accessor: d => (d.first_name),
        Header: "First Name",
        id: "firstName",
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, { threshold: matchSorter.rankings.CONTAINS, keys: ["firstName"] }),
        filterAll: true
      },
      {        
        accessor: d => (d.last_name),
        Header: "Last Name",
        id: "lastName",
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, { threshold: matchSorter.rankings.CONTAINS, keys: ["lastName"] }),
        filterAll: true
      },
      {
        accessor: d => (d.total),
        Header: "Subscriptions Cost",
        id: "Cost",
        Cell: props => formatCurrency(props.value ? props.value : 0, config.language, 2),
        filterable: false
      },
      {
        accessor: d => (d.status),
        Header: "Status",
        id: "status",
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, { threshold: matchSorter.rankings.CONTAINS, keys: ["status"] }),
        filterAll: true
      },
      {
        accessor: d => (d.type),
        id: "type",
        Header: "Type",
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, { threshold: matchSorter.rankings.WORD_STARTS_WITH, keys: ["type"] }),
        filterAll: true
      }
    ];
    if (!subscriptionEnabled) {
      return (<Segment basic>
        <h2>Subscription</h2>
          <h3>Subscriptions is currently disabled. Please contact support to enable this feature.</h3>
      </Segment>)
    }
    else {
      return (
        <Segment basic loading={isLoading}>
          <Confirm
            open={confirm.open}
            content={confirm.content}
            cancelButton={confirm.id > 0 ? "Cancel" : "Close"}
            confirmButton={confirm.id > 0 ? "Confirm" : false}
            onCancel={this.cancelDelete}
            onConfirm={this.confirmDelete}
          />
         <Modal
            open={modal.isOpen}
            closeIcon
            onClose={() => this.confirmModalClose()}
          >
            <Modal.Header content={modal.content} />
            <Modal.Actions>
              <Button negative onClick={() => this.confirmModalClose()}>
                Cancel
              </Button>
              <Button positive onClick={() => modal.isDone()} disabled={false}>
                Confirm
              </Button>
            </Modal.Actions>
          </Modal>
          <Modal
            open={addGroupModalOpen}
            onClose={this.handleAddGroupModalClose}
          >
          <Modal.Header>Create New Subscription Group</Modal.Header>
          <Modal.Content>
          {this.state.modalErrorMessages.length > 0 && (
                <Message
                  error
                  content={this.state.modalErrorMessages.map((item, key) => {
                    return (
                      <span key={`error${key}`}>
                        {item}
                        <br />
                      </span>
                    );
                  })}
                />
              )}
  
             {this.state.modalSuccessMessages && (
                  <Message
                    success
                    content={this.state.modalSuccessMessages}
                  />
                )}
            <Form>
              <Form.Field>
                <label>Name</label>
                <input
                  placeholder='Name'
                  value={this.state.newGroupName}
                  onChange={(e) => this.setState({ newGroupName: e.target.value })}
                />
                <label>Subscription License</label>
                <input
                  placeholder='License'
                  value={this.state.subscriptionLicense}
                  onChange={(e) => this.setState({ subscriptionLicense: e.target.value })}
                />
              </Form.Field>
            </Form>
          </Modal.Content>
          <Modal.Actions>
            <Button onClick={this.handleAddGroupModalClose}>Cancel</Button>
            <Button primary onClick={this.handleNewGroupSave}>Save</Button>
          </Modal.Actions>
        </Modal>
          <PageHeader
            title="Subscriptions"
            breadcrumbs={{
              key: "active",
              content: "Subscriptions",
              active: true
            }}
          />
          <Form.Field>
            <label>Subscription Group</label>
            <Dropdown
              style={{ width: '800px' }}
              placeholder='Select Subscription Group'
              fluid
              selection
              options={this.state.subscriptionGroups.map(group => ({
                key: group.id,
                text: group.name,
                value: group.id
              }))}
              onChange={(e, { value }) => {
                const selectedGroup = this.state.subscriptionGroups.find(group => group.id === value);
                if (selectedGroup) {
                  const selectedGroupName = selectedGroup.name;
                  const activateEventName = selectedGroup.activate_event_name;
                  const activateEventId = selectedGroup.activate_event_id;
                  this.setState({ selectedGroup: value, 
                                  groupName: selectedGroupName, 
                                  activateEventName: activateEventName, 
                                  activateEventId: activateEventId,
                                  totalSubscriptionCount: selectedGroup.total_subscribed_count,
                                  totalSubscriptionAmount: selectedGroup.total_subscribed_amount });
                  this.fetchData(value, 1);
                }
              }}          
            />
          </Form.Field>
  
          <div style={{ paddingTop: '20px' }}>
            <Form
              error={xhrStatus === "error"}
              success={xhrStatus === "success"}
            >
              <Message
              error
              content={xhrMessages.map((item, key) => {
                return (
                  <span key={`error${key}`}>
                    {item}
                    <br />
                  </span>
                );
              })}
            />
            <Message
              success
              content={xhrMessages.map((item, key) => {
                return (
                  <span key={`success${key}`}>
                    {item}
                    <br />
                  </span>
                );
              })}
              />
              <Form.Group widths='equal'>
                <Form.Input
                  style={{ width: '800px' }}
                  name="email"
                  placeholder="search by customer email"
                  value={filtered.email}
                  onChange={this.handleFilter}
                  className="SubscriptionSearch"
                />
                <Form.Field style={{ display: 'flex', paddingRight: '1000px' }} className="SubscriptionSearch">
                  <Button icon="search" primary onClick={() => {this.fetchData(null)}} id="btnSearch" />
                  <Button icon="close" color="red" onClick={this.handleClearSearch} />
                </Form.Field>
              </Form.Group>
            </Form>
          </div>
  
          <div
            style={{
              top: 201,
              display: "flex",
              width: "100%",
              zIndex: 5,
              backgroundColor: "#ffffff",
              padding: "0.6rem 0"
            }}
          >
            <Button
              disabled={false}
              primary
              onClick={() =>
                this.confirmModalOpen(
                  0,
                  <div>
                    <h2>
                      {`Are you sure you'd like to trigger subscription for ${this.state.groupName} ?`}
                    </h2>
                    <br />
                    <p>{`Event ${this.state.activateEventName} will be triggered for this subscription`}</p>
                  </div>,
                  this.triggerPayment
                )
              }
              content="Trigger Subscription"
              className="triggerPayment"
              id="triggerPaymentBtn"
            />
  
            <Button
              disabled={false}
              primary
              onClick={() =>
                this.confirmModalOpen(
                  0,
                  `Are you sure you'd like to cancel all subscriptions for ${this.state.groupName} ?`,
                  this.cancelSubscription
                )
              }
              content="Cancel Subscription"
              className="cancelPayment"
              id="cancelPaymentBtn"
            />
            <Button
              icon="plus"
              style={{marginLeft: 'auto'}} // This will push the button to the right
              disabled={false}
              primary
              onClick={this.handleAddGroupModalOpen}
              content="New Subscription Group"
              className="createSubscriptionGroup"
              id="createSubscriptionGroupId"
            />
          </div>

          { this.state.selectedGroup && (
            <div>
              <h3>Total Subscription Count : {this.state.totalSubscriptionCount}</h3>
              <h3>Total Subscription Amount : {this.state.totalSubscriptionAmount}</h3>
            </div>)
          }
          <Menu secondary stackable>
          </Menu>
          <Divider hidden />
          <ReactTable
            data={data}
            columns={columns}
            className="-striped -highlight"
            loading={isLoading} // Display the loading overlay when we need it          
            resizable
            filterable
            defaultPageSize={limit}
            minRows={0}
            showPagination={false}
            SubComponent={row => {
            if (row.original.detail.length === 0) {
              return null;
            }
             else {
              return (
                <Details details={row.original.detail} />
              );
             }
            }}
          />
        <Pagination
            currentPage={this.state.page}
            totalPages={this.state.pages}
            onPageChange={this.handlePageChange}
        />
        </Segment>
      );
    }
  }
}
Subscription.contextType = AppContext;

export default Subscription;
